import React from 'react'
import { useTranslation } from 'react-i18next'
import { SectionShell } from '../shared/SectionShell'
import { OrbitalMark } from '../shared/OrbitalMark'

const EXCHANGES = [1, 2, 3, 4, 5]

export default function ServicesSection() {
    const { t } = useTranslation()

    return (
        <SectionShell id="services">
            <div className="section-head">
                <span className="section-num">06</span>
                <span className="section-label">{t('services.label')}</span>
            </div>

            <div className="services-header-row">
                <span className="services-col-label">{t('services.client')}</span>
                <span className="services-col-label services-col-label-right">{t('services.me')}</span>
            </div>

            <div className="services-exchanges">
                {EXCHANGES.map((n) => {
                    const sKey = `services.s${n}`
                    return (
                        <div key={n} className="services-exchange">
                            <div className="services-num-tag">/ {String(n).padStart(2, '0')}</div>

                            <div className="services-client-bubble">
                                <span className="services-client-tag">{t('services.client')}</span>
                                <p className="services-client-text">{t(`${sKey}.client`)}</p>
                            </div>

                            <div className="services-me-bubble">
                                <div className="services-me-header">
                                    <OrbitalMark width={24} height={24} className="services-avatar" />
                                    <span className="services-me-tag">{t('services.me')}</span>
                                    <span className="services-service-chip">{t(`${sKey}.tag`)}</span>
                                </div>
                                <p className="services-me-text">{t(`${sKey}.me`)}</p>
                            </div>
                        </div>
                    )
                })}
            </div>
        </SectionShell>
    )
}
